import { render, staticRenderFns } from "./bottomPage.vue?vue&type=template&id=98ced960&scoped=true"
import script from "./bottomPage.vue?vue&type=script&lang=js"
export * from "./bottomPage.vue?vue&type=script&lang=js"
import style0 from "./bottomPage.vue?vue&type=style&index=0&id=98ced960&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98ced960",
  null
  
)

export default component.exports